/* eslint consistent-return: 0 */
import { ServiceCharge, ChargeType } from '../enums/stablishment-tables'
import { theme } from '../styles/theme'

export const getTableServiceChargeType = (
  serviceType: number | null,
  chargeType: ChargeType | null,
): ServiceCharge => {
  if (serviceType === 0) return ServiceCharge.COVER

  if (!serviceType) return ServiceCharge.NONE

  if (
    serviceType === 1
    && chargeType === ChargeType.PERCENTAGE
  ) return ServiceCharge.ATTENDANCE_PERCENTAGE

  return ServiceCharge.ATTENDANCE_FIXED
}

export const calculateServiceCharge = (
  orderPad: any,
  type: ServiceCharge,
  customerQuantity: number | null,
  subtotal: number | null,
) => {
  if (!orderPad) return null
  const value = orderPad?.stablishmentTable?.chargeAmount
  const total = Number(customerQuantity) || Number(subtotal)

  switch (type) {
    case ServiceCharge.NONE:
      return null
    case ServiceCharge.COVER:
      return value * total
    case ServiceCharge.ATTENDANCE_PERCENTAGE:
      return (value / 100) * total
    case ServiceCharge.ATTENDANCE_FIXED:
      return value
    default:
      return null
  }
}

export const tableOrderStatusLabel = {
  0: 'Em aberto',
  1: 'Aguarda fechamento',
  2: 'Mesa vazia',
}

export const orderStatusLabel = {
  0: 'Na cozinha',
  1: 'Em preparo',
  2: 'Esperando entrega',
  3: 'Pedido entregue',
  4: 'Aguardando garçom',
  5: 'Pedido cancelado',
  6: 'Pedido alterado',
  7: 'Pausado',
  8: 'Aguardando pagamento',
  9: 'Pagamento realizado',
}

export const serviceChargeLabel = {
  0: '',
  1: 'Taxa Couver',
  2: 'Taxa Atendimento',
  3: 'Taxa Atendimento',
}

export const orderLightColors = {
  0: theme.colors.lightGreen,
  1: theme.colors.lightPink,
  2: theme.colors.lightBlue,
}

export const orderColors = {
  0: theme.colors.green,
  1: theme.colors.red,
  2: theme.colors.blue,
}

export const generateOrderId = (order: any) => `${order.orderId}#${order.orderPadId}#${order.status}#${order.stablishmentId}#${order.tableId}`
